/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M9.02 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9Zm0 17.05a8 8 0 1 1 8-8.05 8 8 0 0 1-8 8.05Zm2.06-10.08.1.11.71-.63-.09-.11a3.7 3.7 0 0 0-2.23-1V4.2h-1v1.1a2.6 2.6 0 0 0-1.69.7 1.84 1.84 0 0 0-.5 1.36c.06 1.2 1.13 1.67 2.19 1.95v2.55a3.06 3.06 0 0 1-1.86-.88l-.1-.1-.67.68.1.1a4.24 4.24 0 0 0 2.54 1.16v1.07h.95v-1.07a2.81 2.81 0 0 0 1.76-.75 1.86 1.86 0 0 0 .52-1.4c-.06-1.37-1.15-1.8-2.29-2.1v-2.3a2.65 2.65 0 0 1 1.56.7ZM8.62 8.31c-1.11-.33-1.22-.68-1.24-1a.91.91 0 0 1 .24-.65 1.62 1.62 0 0 1 1-.41Zm2.28 2.4a.91.91 0 0 1-.25.7 2 2 0 0 1-1.08.46V9.55c1 .29 1.31.57 1.33 1.16Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'CircleWithDollarSignIcon';

export default Icon;
